import {query} from 'api';
import PropType from 'prop-types';
import Article from './article';
import {lifecycle} from 'recompose';

const ArticlePage = ({data}) => {
  if (!data) return null;
  return data.map(article => <Article key={article.id} id={article.id} {...article.acf} />);
};

ArticlePage.propTypes = {
  data: PropType.array.isRequired,
};

export default ArticlePage
  |> lifecycle({
    componentDidMount() {
      const {data, onEndReached} = this.props;
      if (data.length === 0) {
        onEndReached();
      }
    },
  })
  |> query('getArticlesByPage', {loadingFullWidth: true}, ({page}) => `/${page}`);
